<template>
  <section class="match-detail-schedule-section">
    <div class="schedule-title">
      <img :src="scheduleData.titleImage" alt="赛事安排" />
    </div>

    <div class="schedule-timeline">
      <img :src="scheduleData.timelineImage" alt="赛事安排时间轴" />
    </div>

    <div class="schedule-date-list">
      <div v-for="item in scheduleList" :key="item.id" class="schedule-date">
        {{ item.date }}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'MatchDetailScheduleSection',
  props: {
    scheduleData: { type: Object, required: true },
    scheduleList: { type: Array, required: true },
  },
}
</script>

<style scoped lang="scss">
.match-detail-schedule-section {
  padding-top: 0.369792rem;
  padding-bottom: 0.604167rem;
  background: #e7eaed url('@/assets/image/match/pc/match/news-section-bg.png') center top / cover no-repeat;
  box-sizing: border-box;

  .schedule-title {
    width: 6.880208rem;
    height: 0.875rem;
    margin: 0 auto;

    img {
      display: block;
      width: 6.880208rem;
      height: 0.875rem;
      object-fit: contain;
    }
  }

  .schedule-timeline {
    width: 7.291667rem;
    height: 3.09375rem;
    margin: 0.135417rem auto 0;

    img {
      display: block;
      width: 7.291667rem;
      height: 3.09375rem;
      object-fit: contain;
    }
  }

  .schedule-date-list {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    width: 7.291667rem;
    height: 0.177083rem;
    margin: 0 auto;
  }

  .schedule-date {
    font-weight: bold;
    height: 0.177083rem;
    color: #8b4900;
    font-size: 0.145833rem;
    line-height: 0.177083rem;
    text-align: center;
    white-space: nowrap;
  }

  @media (max-width: 750px) {
    padding: 10vw 0 13vw;
    background: transparent;

    .schedule-title {
      width: 90%;
      height: auto;

      img {
        width: 100%;
        height: auto;
      }
    }

    .schedule-timeline {
      width: 100%;
      height: auto;
      margin-top: 5vw;

      img {
        width: 100%;
        height: auto;
      }
    }

    .schedule-date-list {
      grid-template-columns: repeat(4, minmax(0, 1fr));
      width: 98%;
      height: auto;
      margin-top: 4vw;
      row-gap: 0;
    }

    .schedule-date {
      height: auto;
      font-size: 2.6vw;
      line-height: 1.6;
      white-space: nowrap;
    }
  }
}
</style>
